<div class="time-box">
    <p>{{ countdown.days }}</p>
    <span>:</span>
    <p>{{ countdown.hours }}</p>
    <span>:</span>
    <p>{{ countdown.minutes }}</p>
    <span>:</span>
    <p>{{ countdown.seconds }}</p>
</div>